<!--
 * @Description:
 * @Author: -898-
 * @Date: 2024-05-10 15:59:54
 * @LastEditTime: 2025-02-24 17:20:52
 * @LastEditors: -898-
-->
<template>
  <div>
    <el-image
      v-if="dialogImageUrlVisible"
      v-show="false"
      ref="elImage"
      :src="dialogImageUrl"
      :preview-src-list="[dialogImageUrl]"
      fit="contain"
      @click.native.stop="handlePreviewClose()"
    >
    </el-image>
    <!-- <el-image-viewer
      v-if="dialogImageUrlVisible"
      :on-close="handleViewerClose"
      :url-list="[dialogImageUrl]"
    ></el-image-viewer> -->
  </div>
</template>
<script>
import { getToken } from "@/utils/auth";
export default {
  name: "CtPreviewImage",
  props: {
    imageInfo: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogImageUrlVisible: false,
      dialogImageUrl: "",
      domImageClose: "",
      domImageMask: "",
    };
  },
  watch: {
    imageInfo: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.dialogImageUrl =
            process.env.VUE_APP_PREVIEW_API + JSON.parse(newVal)[0].fileId;
          this.$nextTick(() => {
            this.$refs.elImage.clickHandler();
            this.getElements(newVal);
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    setVisible(val) {
      this.dialogImageUrlVisible = !!val;
    },
    handlePreviewClose() {
      this.domImageMask.addEventListener("click", (event) => {
        this.dialogImageUrlVisible = false;
        this.$emit("previewImage");
      });
      this.domImageClose.addEventListener("click", () => {
        this.dialogImageUrlVisible = false;
        this.$emit("previewImage");
        // document.querySelector(".el-image-viewer__close").click();
      });
    },
    getElements(val) {
      this.$nextTick((_) => {
        let wrapper = document.getElementsByClassName("el-image-viewer__actions__inner");
        this.domImageClose = document.getElementsByClassName("el-image-viewer__close")[0];
        this.domImageMask = document.getElementsByClassName("el-image-viewer__mask")[0];
        let downImg = document.createElement("i");
        downImg.setAttribute("class", "el-icon-download");
        wrapper[0].appendChild(downImg);
        if (wrapper.length > 0) {
          this.wrapperElem = wrapper[0].lastElementChild;
          this.cusClickHandler(val);
          this.handlePreviewClose();
        }
      });
    },
    cusClickHandler(val) {
      let downloadElem = document.getElementsByClassName("el-icon-download");
      this.wrapperElem.addEventListener("click", () => {
        this.downloadImage(val);
      });
    },
    downloadImage(val) {
      console.log(Array.isArray(val));
      if (JSON.parse(val) && JSON.parse(val).length) {
        let fileData = JSON.parse(val)[0].name.split(".");
        let fileId = JSON.parse(val)[0].fileId;
        if (getToken()) {
          this.download(
            "/file/pri/download",
            {
              fileId: fileId,
            },
            `${fileData[0]}_${new Date().getTime()}.${fileData[fileData.length - 1]}`
          );
        } else {
          this.download(
            "/file/pub/download",
            {
              fileId: fileId,
            },
            `${fileData[0]}_${new Date().getTime()}.${fileData[fileData.length - 1]}`
          );
        }
        // this.download(
        //   "/common/download/resource",
        //   {
        //     resource: JSON.parse(val)[0].url,
        //   },
        //   `${fileData[0]}_${new Date().getTime()}.${fileData[fileData.length - 1]}`
        // );
      }
    },
  },
};
</script>
